"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypesCollection_1 = require("../DataModel/Collections/TypesCollection");
const namespaces_1 = require("../namespaces");
function createStateFrom(iri, view) {
    return update({}, iri, view);
}
function update(state, iri, view) {
    state.current = iri;
    state.first = view.first;
    state.next = view.next;
    state.prev = view.previous;
    state.last = view.last;
    return state;
}
async function getPart(state, link, client) {
    const collectionPart = await client.getResource(link);
    let page = collectionPart;
    if (!page.view) {
        page = collectionPart.where(_ => !!_.view).first();
    }
    update(state, page.view.iri, page.view);
    return page.members;
}
function getTargetOf(link) {
    return !!link ? link.iri : null;
}
function partialCollectionIteratorFactory(resource, client, processingState) {
    const target = resource;
    const collection = resource;
    const viewIri = processingState.processedObject[namespaces_1.hydra.view]
        ? processingState.processedObject[namespaces_1.hydra.view][0]["@id"]
        : null;
    const getIterator = () => {
        const state = createStateFrom(collection.iri, collection.view);
        const result = {
            getFirstPart: () => getPart(state, state.first, client),
            getLastPart: () => getPart(state, state.last, client),
            getNextPart: () => getPart(state, state.next, client),
            getPreviousPart: () => getPart(state, state.prev, client),
            type: new TypesCollection_1.default([namespaces_1.hydra.PartialCollectionView])
        };
        Object.defineProperty(result, "currentPartIri", { get: () => state.current });
        Object.defineProperty(result, "firstPartIri", { get: () => getTargetOf(state.first) });
        Object.defineProperty(result, "nextPartIri", { get: () => getTargetOf(state.next) });
        Object.defineProperty(result, "previousPartIri", { get: () => getTargetOf(state.prev) });
        Object.defineProperty(result, "lastPartIri", { get: () => getTargetOf(state.last) });
        Object.defineProperty(result, "hasNextPart", { get: () => !!state.next });
        Object.defineProperty(result, "hasPreviousPart", { get: () => !!state.prev });
        return result;
    };
    Object.defineProperty(target, "getIterator", { value: viewIri ? getIterator : () => null, writable: false });
    return resource;
}
exports.partialCollectionIteratorFactory = partialCollectionIteratorFactory;
//# sourceMappingURL=partialCollectionIteratorFactory.js.map